import { NhealthAction } from "./action.api";
import { DecryptedOBJ, EncryptedOBJ, EncryptedText } from "../utils/Encryption";
import liff from "@line/liff";
import lineConfig from "./authLine/lineConfig";
import { Base_API } from "./matcher";
import useLineLogin from "./authLine/lineLogin";
import { getHeadersAuthenLineId } from "./sso.authen";

export {
    getProvince,
    getDistrict,
    getSubdistrict,
    getPostalcode,
}

const getProvince = (lang) => {
    return new Promise(async (resolve) => {
        let headers = await getHeadersAuthenLineId();
        NhealthAction.getProvince(lang, headers)
        .then(res => {
            if (res.IsSuccess) {
                resolve(res.data);
            }
        })
    })
}


const getDistrict = (lang, coderef) => {
    return new Promise(async (resolve) => {
        let headers = await getHeadersAuthenLineId();
        NhealthAction.getDistrict(lang, coderef, headers)
        .then(res => {
            if (res.IsSuccess) {
                resolve(res.data);
            }
        })
    })
}

const getSubdistrict = (lang, coderef) => {
    return new Promise(async (resolve) => {
        let headers = await getHeadersAuthenLineId();
        NhealthAction.getSubdistrict(lang, coderef, headers)
        .then(res => {
            if (res.IsSuccess) {
                resolve(res.data);
            }
        })
    })
}

const getPostalcode = (lang, coderef) => {
    return new Promise(async (resolve) => {
        let headers = await getHeadersAuthenLineId();
        NhealthAction.getPostalcode(lang, coderef, headers)
        .then(res => {
            if (res.IsSuccess) {
                resolve(res.data);
            }
        })
    })
}